import React from 'react';
import { Route} from 'react-router-dom';

import {PaginaInicial, FormularioDevolucao, GerenciarDevolucoes} from '../paginas';

import {Menu} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faListAlt, faPlus } from '@fortawesome/pro-light-svg-icons'
import { Link } from 'react-router-dom';

const {SubMenu} = Menu;


const MainMenu = ({callbackSelect}) => {
    const pathname = window.location.pathname;
    const onClickHandle = (evt) => {
        callbackSelect && callbackSelect(evt);
    }
    return (<Menu 
        mode='inline'
        defaultSelectedKeys={[pathname]} >

                <Menu.Item key='/' onClick={onClickHandle} icon={<FontAwesomeIcon icon={faListAlt} /> }><Link to="/"> Gerenciar Devoluções</Link></Menu.Item>                  
            
                <Menu.Item key='nova-devolucao' onClick={onClickHandle}  icon={<FontAwesomeIcon icon={faPlus} /> }><Link to="/nova-devolucao"> Nova Devolução</Link></Menu.Item>                  
{/*                 
                <Menu.Item key='configuracao' onClick={onClickHandle} icon={<FontAwesomeIcon icon={faCog} /> }> Configurações</Menu.Item>                  

                <SubMenu key="compras" title="Compras" icon={<FontAwesomeIcon icon={faCog} />}>
                    <Menu.Item><Link to='/gerenciar'>Gerenciar</Link></Menu.Item>
                    <Menu.Item><Link to='/relatorios'>Relatorios</Link></Menu.Item>
                </SubMenu>
                <SubMenu key="produtos" title="Produtos" icon={<FontAwesomeIcon icon={faCog} />}>
                    <Menu.Item>Gerenciar</Menu.Item>
                    <Menu.Item>Relatorios</Menu.Item>
                </SubMenu>
                <SubMenu key="pedidos" title="Pedidos" icon={<FontAwesomeIcon icon={faCog} />}>
                    <Menu.Item>Sub Menu</Menu.Item>
                    <Menu.Item>etc</Menu.Item>
                </SubMenu> */}
    </Menu>);
}



const getMainMenuRouter = () => {
    return ( <>
    <Route exact path="/" component={GerenciarDevolucoes}/>
    <Route exact path="/nova-devolucao" component={FormularioDevolucao}/>
    
    </>);
}

export {MainMenu, getMainMenuRouter};